import { Link } from "react-router-dom";
import "./dashboard.menu.scss";
import { useSidebarStore } from "../../../context";
import { useEffect, useState } from "react";

interface DashboardMenuItemProps {
  path: string;
  title: string;
  icon?: React.ReactNode;
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
}

export function DashboardMenuItem({
  path,
  title,
  icon,
  className,
  onClick,
}: DashboardMenuItemProps) {
  const { toggleDashSidebar } = useSidebarStore();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsMobile(width < 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleClick = (e: React.MouseEvent) => {
    if (onClick) onClick(e);
    if (isMobile) toggleDashSidebar();
  };
  return (
    <li className={className}>
      <Link to={path} onClick={handleClick} className="flex items-center">
        <span className="icon-container">{icon}</span>
        <span className="menu-title">{title}</span>
        <span className="menu-badge"></span>
      </Link>
    </li>
  );
}

interface DashboardMenuProps {
  children: React.ReactNode;
}

export function DashboardMenu({ children }: DashboardMenuProps) {
  return <ul className="dashboard-menu">{children}</ul>;
}
